exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-046a1e61] .avatar-uploader .avatar-uploader-icon{height:0.66667rem;line-height:0.66667rem}", ""]);

// exports
